const nextRouteMixin = {
  methods: {
    goToNextRoute() {
      return this.$router
        .push(this.$router.currentRoute.meta.nextRoute)
        .catch(() => {});
    },
  },
};

export default nextRouteMixin;
